import {hasAllChooserSelections} from './scenarioApplyResult';

export const CON13299_LOG_PREFIX = '[CON-13299]';

function idOf(value) {
    if (!value) {
        return null;
    }
    if (typeof value === 'string' || typeof value === 'number') {
        return value;
    }
    return value.realId || value.id || null;
}

export function buildScenarioApplyClientDiag(component, extra) {
    const state = (component && component.state) || {};
    const props = (component && component.props) || {};
    const query = (props.location && props.location.query) || {};
    const scenario = (component && typeof component.getScenario === 'function')
        ? component.getScenario()
        : state.scenario;
    const organisation = props.user && props.user.organisation;
    const channelSelect = state.channelSelect || {};

    return Object.assign({
        scenarioId: idOf(scenario),
        organisationId: idOf(organisation),
        configurationStep: state.configurationStep,
        grantedStep: query.grantedStep || null,
        grantedChannelId: query.grantedChannelId || null,
        grantedChannelDefId: query.grantedChannelDefId || null,
        channelSelectKeys: Object.keys(channelSelect),
        channelSelectIds: Object.keys(channelSelect).map((key) => ({
            key,
            channelId: idOf(channelSelect[key]),
        })),
        chooserGroupKeys: (state.channelsToSelect || []).map((group) => group && group.groupKey),
        chooserChannelIds: (state.channelsToSelect || []).map((group) => ({
            groupKey: group && group.groupKey,
            channelIds: (group && group.channels || []).map(idOf),
        })),
        hasAllSelections: hasAllChooserSelections(state.channelsToSelect, channelSelect),
        onFlowSettings: !!(component && typeof component.isOnFlowSettingsStep === 'function' && component.isOnFlowSettingsStep()),
        onFinish: !!(component && typeof component.isOnFinishApplyStep === 'function' && component.isOnFinishApplyStep()),
        applyFailed: !!state.applyFailed,
        hasFlow: !!idOf(state.flow),
        isSaving: !!state.isSaving,
        finalSaving: !!(component && component.finalSaving),
        wasSuccess: !!state.wasSuccess,
        hasErrors: !!state.errors,
        loading: !!state.loading,
    }, extra || {});
}

export function logScenarioApplyClientDiag(event, payload) {
    const body = Object.assign({event}, payload || {});
    const line = CON13299_LOG_PREFIX + ' ' + JSON.stringify(body);
    try {
        // eslint-disable-next-line no-console
        console.warn(line);
    } catch (_ignored) {
        /* ignore */
    }
}

export function logScenarioApplyClientDiagOnce(component, event, payload) {
    const key = event + ':' + JSON.stringify(payload || {});
    if (component && component._con13299LastKey === key) {
        return;
    }
    if (component) {
        component._con13299LastKey = key;
    }
    logScenarioApplyClientDiag(event, payload);
}
